import type { QueueItem } from "@/app/reviewQueries";
import { BUCKETS, bucketCounts, type BucketId, type Tone } from "./model";

export const TONE_CLASS: Record<Tone, string> = {
  err: "text-err",
  warn: "text-warn",
  ok: "text-ok",
  mut: "text-mut",
  info: "text-info",
  ink: "text-ink",
};

/** Четыре карточки-корзины. Счётчики — из полного списка режима, поиск на них не влияет. */
export function Buckets({ all, value, onChange }: { all: QueueItem[]; value: BucketId; onChange: (id: BucketId) => void }) {
  const counts = bucketCounts(all);
  return (
    <div className="grid grid-cols-2 gap-2.5 md:grid-cols-4" role="group" aria-label="корзины очереди">
      {BUCKETS.map((b) => {
        const on = b.id === value;
        return (
          <button
            key={b.id}
            type="button"
            aria-pressed={on}
            data-testid={`bucket-${b.id}`}
            data-count={counts[b.id]}
            onClick={() => onChange(b.id)}
            className={`flex flex-col items-start gap-1 rounded-md border px-3.5 py-3 text-left ${on ? "border-acc bg-card" : "border-bd bg-transparent hover:border-bd2"}`}
          >
            <span className={`font-mono text-[24px] font-bold leading-none ${TONE_CLASS[b.tone]}`}>{counts[b.id]}</span>
            <span className={`font-mono text-[11.5px] ${on ? "text-ink" : "text-mut"}`}>{b.label}</span>
          </button>
        );
      })}
    </div>
  );
}
